'use strict';
import {ModalHOC} from '../../../core-utilities/react-modals/ModalContainer';
import {IonicModal} from '../../../core-utilities/react-modals/IonicModal';
import {InfoModalComponent} from './InfoModalComponent';
export {modalOptions} from './InfoModalComponent';

export const InfoModal = ModalHOC(IonicModal, InfoModalComponent);



// WEBPACK FOOTER //
// ./src/js/requirements/components/InfoModal/index.js